var render = function render(){var _vm=this,_c=_vm._self._c;return _c('flex-line',{attrs:{"show-border":true}},[_c('label',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{attrs:{"slot":"right"},slot:"right"},[(_vm.discount)?_c('label',{staticClass:"subtitle discount"},[_vm._v("-$"+_vm._s(_vm.subtitle))]):_c('label',{staticClass:"subtitle"},[_vm._v("$"+_vm._s(_vm.subtitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }